import { render } from "./Bank.vue?vue&type=template&id=1bf7b6fa&ts=true"
import script from "./Bank.vue?vue&type=script&lang=ts"
export * from "./Bank.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__